import React from "react";
import { useNavigate } from "react-router-dom";

const HelpPage = () => {
  const navigate = useNavigate();

  return (
    <div
      className="min-h-screen flex items-center justify-center px-4 py-12"
      style={{
        background:
          "linear-gradient(145deg, #0B4F4A 0%, #005F5A 25%, #009689 60%, #00BBA7 100%)",
      }}
    >
      {/* Decorative blobs */}
      <div className="fixed inset-0 pointer-events-none overflow-hidden">
        <div
          className="absolute -top-40 -right-40 w-[500px] h-[500px] rounded-full opacity-20"
          style={{
            background: "radial-gradient(circle, #00D5BE 0%, transparent 70%)",
          }}
        />
        <div
          className="absolute -bottom-40 -left-40 w-[400px] h-[400px] rounded-full opacity-15"
          style={{
            background: "radial-gradient(circle, #0B4F4A 0%, transparent 70%)",
          }}
        />
        <div
          className="absolute inset-0 opacity-[0.04]"
          style={{
            backgroundImage:
              "radial-gradient(circle at 1px 1px, rgba(255,255,255,0.6) 1px, transparent 0)",
            backgroundSize: "28px 28px",
          }}
        />
      </div>

      <div className="relative z-10 w-full max-w-lg">
        {/* Back button */}
        <button
          onClick={() => navigate(-1)}
          className="flex items-center gap-2 text-sm font-medium mb-6 transition-all"
          style={{ color: "#CBFBF1" }}
          onMouseOver={(e) => (e.currentTarget.style.color = "white")}
          onMouseOut={(e) => (e.currentTarget.style.color = "#CBFBF1")}
        >
          <svg
            className="w-4 h-4"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M15 19l-7-7 7-7"
            />
          </svg>
          Kembali
        </button>

        {/* Card */}
        <div
          className="rounded-2xl p-8"
          style={{
            background: "rgba(255,255,255,0.92)",
            backdropFilter: "blur(20px)",
            border: "1.5px solid rgba(255,255,255,0.5)",
            boxShadow: "0 20px 60px rgba(11,79,74,0.35)",
          }}
        >
          {/* Header */}
          <div
            className="flex items-center gap-3 mb-6 pb-5"
            style={{ borderBottom: "1.5px solid #F0FDFA" }}
          >
            <div
              className="w-10 h-10 rounded-xl flex items-center justify-center shrink-0"
              style={{
                background: "linear-gradient(135deg, #CBFBF1, #96F7E4)",
              }}
            >
              <svg
                className="w-5 h-5"
                style={{ color: "#009689" }}
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            </div>
            <h1 className="text-xl font-bold" style={{ color: "#0B4F4A" }}>
              Butuh Bantuan?
            </h1>
          </div>

          {/* Content */}
          <div className="flex flex-col gap-4">
            <p className="text-sm" style={{ color: "#005F5A" }}>
              Hubungi Customer Support:
            </p>

            {/* Company card */}
            <div
              className="rounded-xl p-5 flex flex-col gap-3"
              style={{ background: "#F0FDFA", border: "1.5px solid #CBFBF1" }}
            >
              <p className="text-sm font-bold" style={{ color: "#0B4F4A" }}>
                PT Bank Syariah Indonesia Tbk Kantor Pusat
              </p>

              {/* Address */}
              <div className="flex items-start gap-3">
                <div
                  className="w-7 h-7 rounded-lg flex items-center justify-center shrink-0 mt-0.5"
                  style={{ background: "white", border: "1.5px solid #CBFBF1" }}
                >
                  <svg
                    className="w-3.5 h-3.5"
                    style={{ color: "#009689" }}
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                    />
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                    />
                  </svg>
                </div>
                <p className="text-sm" style={{ color: "#005F5A" }}>
                  Gedung The Tower, Jl. Gatot Subroto No. 27
                  <br />
                  Jakarta Selatan 12930, Indonesia
                </p>
              </div>

              {/* Phone */}
              <div className="flex items-center gap-3">
                <div
                  className="w-7 h-7 rounded-lg flex items-center justify-center shrink-0"
                  style={{ background: "white", border: "1.5px solid #CBFBF1" }}
                >
                  <svg
                    className="w-3.5 h-3.5"
                    style={{ color: "#009689" }}
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                    />
                  </svg>
                </div>
                <div>
                  <p className="text-xs" style={{ color: "#009689" }}>
                    Layanan Nasabah (BSI Call)
                  </p>
                  <a
                    href="tel:14040"
                    className="text-sm font-semibold transition-colors"
                    style={{ color: "#0B4F4A" }}
                    onMouseOver={(e) =>
                      (e.currentTarget.style.color = "#009689")
                    }
                    onMouseOut={(e) =>
                      (e.currentTarget.style.color = "#0B4F4A")
                    }
                  >
                    14040
                  </a>
                </div>
              </div>

              {/* WhatsApp */}
              <div className="flex items-center gap-3">
                <div
                  className="w-7 h-7 rounded-lg flex items-center justify-center shrink-0"
                  style={{ background: "white", border: "1.5px solid #CBFBF1" }}
                >
                  <svg
                    className="w-3.5 h-3.5"
                    style={{ color: "#009689" }}
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
                  </svg>
                </div>
                <div>
                  <p className="text-xs" style={{ color: "#009689" }}>
                    Official WhatsApp Bank BSI
                  </p>
                  <a
                    href="https://wa.me/6281584114040"
                    target="_blank"
                    rel="noreferrer"
                    className="text-sm font-semibold transition-colors"
                    style={{ color: "#0B4F4A" }}
                    onMouseOver={(e) =>
                      (e.currentTarget.style.color = "#009689")
                    }
                    onMouseOut={(e) =>
                      (e.currentTarget.style.color = "#0B4F4A")
                    }
                  >
                    0815-8411-4040
                  </a>
                </div>
              </div>

              {/* Email */}
              <div className="flex items-center gap-3">
                <div
                  className="w-7 h-7 rounded-lg flex items-center justify-center shrink-0"
                  style={{ background: "white", border: "1.5px solid #CBFBF1" }}
                >
                  <svg
                    className="w-3.5 h-3.5"
                    style={{ color: "#009689" }}
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                    />
                  </svg>
                </div>
                <div>
                  <p className="text-xs" style={{ color: "#009689" }}>
                    Email
                  </p>
                  <a
                    href="mailto:contactus@bankbsi.co.id"
                    className="text-sm font-semibold transition-colors"
                    style={{ color: "#0B4F4A" }}
                    onMouseOver={(e) =>
                      (e.currentTarget.style.color = "#009689")
                    }
                    onMouseOut={(e) =>
                      (e.currentTarget.style.color = "#0B4F4A")
                    }
                  >
                    contactus@bankbsi.co.id
                  </a>
                </div>
              </div>

              {/* Website */}
              <div className="flex items-center gap-3">
                <div
                  className="w-7 h-7 rounded-lg flex items-center justify-center shrink-0"
                  style={{ background: "white", border: "1.5px solid #CBFBF1" }}
                >
                  <svg
                    className="w-3.5 h-3.5"
                    style={{ color: "#009689" }}
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9"
                    />
                  </svg>
                </div>
                <div>
                  <p className="text-xs" style={{ color: "#009689" }}>
                    Website
                  </p>
                  <a
                    href="https://www.bankbsi.co.id"
                    target="_blank"
                    rel="noreferrer"
                    className="text-sm font-semibold transition-colors"
                    style={{ color: "#0B4F4A" }}
                    onMouseOver={(e) =>
                      (e.currentTarget.style.color = "#009689")
                    }
                    onMouseOut={(e) =>
                      (e.currentTarget.style.color = "#0B4F4A")
                    }
                  >
                    www.bankbsi.co.id
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HelpPage;
